var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load",style:({height: _vm.height + 'px', width: _vm.width+ 'px'})},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"la-line-scale-pulse-out",staticStyle:{"color":"#34baffb3"}},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }